export const dataDays = [{
  word: 'Dimanch',
  partOfSpeech: 'N',
  definition: ['Sunday'],
  egSentenceKw: 'Lé Dimanch nou ka alé légliz.',
  egSentenceEn: 'Sundays we go to church.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dimanche]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Lendi',
  partOfSpeech: 'N',
  definition: ['Monday'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. lundi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Madi',
  partOfSpeech: 'N',
  definition: ['Tuesday'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mardi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Mékwédi',
  partOfSpeech: 'N',
  definition: ['Wednesday'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mercredi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Jédi',
  partOfSpeech: 'N',
  definition: ['Thursday'],
  egSentenceKw: 'Nou ka fè konmisyon toulé Jédi.',
  egSentenceEn: 'We do errands every Thursday.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. jeudi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Vandwédi',
  partOfSpeech: 'N',
  definition: ['Friday'],
  egSentenceKw: 'Nou ka lavé had-la chak Vandwédi.',
  egSentenceEn: 'We wash clothes every Friday.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. vendredi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Sanmdi',
  partOfSpeech: 'N',
  definition: ['Saturday'],
  egSentenceKw: 'Toulé Sanmdi yo ka alé laplas.',
  egSentenceEn: 'Every Saturday they go to the market.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. samedi]',
  dialect: '🇱🇨',
  variant: [null],
},
];
